module.exports = __webpack_public_path__ + "img/symbol_7.4416b6b0.png";